import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { createUsePuck } from '@puckeditor/core';

import ClearableNumberInput from '../Common/ClearableNumberInput';
import RadioField from '../Common/RadioField';
import { normalizePageVisibilityMode } from '../../../../helpers/PageSections';

const usePuckSelector = createUsePuck();

export const FeatureCollectionsRadioField = ({
  id,
  name,
  hint,
  value,
  onChange,
  field,
  readOnly,
}) => (
  <RadioField
    id={id}
    name={name}
    hint={hint}
    label={field.label}
    value={value}
    onChange={onChange}
    options={field.options}
    readOnly={readOnly}
  />
);

FeatureCollectionsRadioField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  hint: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  field: PropTypes.shape({
    label: PropTypes.string,
    options: PropTypes.array,
  }).isRequired,
};

FeatureCollectionsRadioField.defaultProps = {
  id: '',
  name: '',
  hint: '',
  value: false,
  readOnly: false,
};

export const FeaturedCountField = ({
  value, onChange, field, hint,
}) => {
  const selectedItem = usePuckSelector((s) => s.selectedItem);
  const featureCollectionsEnabled = selectedItem?.props?.featureCollections === true;

  if (!featureCollectionsEnabled) {
    return <div className="puck-featured-count-hidden" />;
  }

  return (
    <ClearableNumberInput
      hint={hint}
      value={value}
      onChange={onChange}
      label={field.label}
      min={1}
      step={1}
    />
  );
};

FeaturedCountField.propTypes = {
  hint: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  field: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
};

FeaturedCountField.defaultProps = {
  hint: '',
  value: null,
};

export const CollectionDownloadField = ({
  value,
  onChange,
  field,
}) => {
  const visibilityMode = usePuckSelector((s) => s.appState?.data?.root?.props?.visibility_mode);
  const isHomepageVisibilityMode = normalizePageVisibilityMode(visibilityMode) === 'homepage';

  useEffect(() => {
    if (isHomepageVisibilityMode && value !== false) {
      onChange(false);
    }
  }, [isHomepageVisibilityMode, onChange, value]);

  if (isHomepageVisibilityMode) {
    return <div className="puck-download-setting-hidden" />;
  }

  return (
    <FeatureCollectionsRadioField
      id="puck-collection-download"
      name="puckCollectionDownload"
      value={value}
      onChange={onChange}
      field={field}
    />
  );
};

CollectionDownloadField.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  field: PropTypes.shape({
    label: PropTypes.string,
    options: PropTypes.array,
  }).isRequired,
};

CollectionDownloadField.defaultProps = {
  value: true,
};
